{
  "definitive": "Eerste en tweede invoer klaar",
  "empty": "Eerste invoer nog niet gestart",
  "entries_different": "Verschil 1e en 2e invoer",
  "errors_and_warnings": "Fouten en waarschuwingen",
  "first_and_second_entry_finished": "1e en 2e invoer klaar",
  "first_entry_correction": "Eerste invoer bezig",
  "first_entry_finalised": "Tweede invoer nog niet gestart",
  "first_entry_finished": "Eerste invoer klaar",
  "first_entry_finished_short": "1e invoer klaar",
  "first_entry_has_errors": "Fouten in proces-verbaal",
  "first_entry_in_progress": "Eerste invoer bezig",
  "in_progress": "Invoer bezig",
  "not_started": "Werkvoorraad",
  "second_entry_correction": "Tweede invoer bezig",
  "second_entry_in_progress": "Tweede invoer bezig"
}
